import { program } from "../activity";

program.parse(process.argv);
